import { api } from "api/loginRoutes"
import { createAction } from "./defaults"
import {
    FULL_REPORT_SET_LIST,
    FULL_REPORT_SET_LOADING
} from "./actionTypes";
import { FULL_REPORT_LIST_METHOD, SMS_FULL_REPORT_LIST_METHOD } from "const/apiMethods";
import { FULL_REPORT_PER_PAGE } from "const/localStorageKeys";
import { DEFAULT_PER_PAGE_BIG } from "const";
import { DESC_SORT } from "const";
import { getISOTime, toUTCDateTime, removeTZFromDate, toStartDayTime, toEndDayTime, servicePick } from "utils";

const setLoading = createAction(FULL_REPORT_SET_LOADING);
const setFullReportList = createAction(FULL_REPORT_SET_LIST);

export const getFullReportList = (service = true, filter = {}, page = 1, perPage = DEFAULT_PER_PAGE_BIG, sort = {}) => (dispatch) => {
    dispatch(setLoading(true));

    const sort1 = sort.column;
    const sort1Desc = sort.type && sort.type === DESC_SORT;

    const currentFilter = { ...filter };

    if (currentFilter.range && currentFilter.range.length) {
        currentFilter["start_date"] = currentFilter.range[0];
        currentFilter["end_date"] = currentFilter.range[1];

        delete currentFilter.range;
    }

    const params = {
        filter: currentFilter,
        page,
        per_page: perPage,
        sort1,
        sort1_desc: sort1Desc
    };

    const method = servicePick(service, FULL_REPORT_LIST_METHOD, SMS_FULL_REPORT_LIST_METHOD);

    api(method, params)
        .then((result) => {
            dispatch(setFullReportList({
                list: result?.full_report_list,
                more: result?.full_report_more,
                count: result?.full_report_count,
                perPage: perPage,
                page: page
            }));
        })
        .catch((error) => {
            dispatch(setLoading(false));
        })
};